import React, { useEffect, useState, useCallback } from 'react'
import ResourceForm from './ResourceForm'
import Loader from '../shared/Loader'
import ResourcesService from '../../services/api/ResourcesService'

const ResourceEdit = ({ ensembleId, resourceId }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [formErrors, setFormErrors] = useState({})

  useEffect(() => {
    const fetchResource = async() => {
      try {
        setLoading(true)
        const response = await ResourcesService.getResource(ensembleId, resourceId)
        setData(response)
        setError(null)
      } catch {
        setError('Erreur lors du chargement de la ressource')
      } finally {
        setLoading(false)
      }
    }

    fetchResource()
  }, [ensembleId, resourceId])

  const handleSubmit = useCallback(async submitData => {
    setSubmitting(true)
    setFormErrors({})

    try {
      const result = await ResourcesService.updateResource(ensembleId, resourceId, submitData)
      if (result.success === true) {
        const noticeParam = result.notice ? `?notice=${encodeURIComponent(result.notice)}` : ''
        window.location.href = `/ensembles/${ensembleId}/resources${noticeParam}`
      }
      else {
        setFormErrors(result.formatted_errors || {})
        setSubmitting(false)
      }
    } catch (err) {
      const errorMessage = err.message || 'Une erreur est survenue lors de la mise à jour'
      setFormErrors({ base: [errorMessage] })
      setSubmitting(false)
    }
  }, [ensembleId, resourceId])

  if (loading) {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <div className="row">
            <div className="col-md-6">
              <h2 className="d-inline">
                <i className="fas fa-cube" />
                {' Edition d\'une ressource'}
              </h2>
            </div>
            <div className="col-md-6">
              <a
                className="btn btn-primary float-md-right mt-2 mt-md-0"
                href={`/ensembles/${ensembleId}/resources`}
              >
                <i className="fas fa-reply" />
                {' Retour'}
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <Loader text="Chargement de la ressource en cours..." />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <div className="row">
            <div className="col-md-6">
              <h2 className="d-inline">
                <i className="fas fa-cube" />
                {' Edition d\'une ressource'}
              </h2>
            </div>
            <div className="col-md-6">
              <a
                className="btn btn-primary float-md-right mt-2 mt-md-0"
                href={`/ensembles/${ensembleId}/resources`}
              >
                <i className="fas fa-reply" />
                {' Retour'}
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="alert alert-danger">
            {error}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header bg-light">
        <div className="row">
          <div className="col-md-6">
            <h2 className="d-inline">
              <i className="fas fa-cube" />
              {' Edition d\'une ressource'}
            </h2>
          </div>
          <div className="col-md-6">
            <a
              className="btn btn-primary float-md-right mt-2 mt-md-0"
              href={`/ensembles/${ensembleId}/resources`}
            >
              <i className="fas fa-reply" />
              {' Retour'}
            </a>
          </div>
        </div>
      </div>
      <div className="card-body">
        {data ? (
          <ResourceForm
            data={data}
            submitting={submitting}
            errors={formErrors}
            mode="edit"
            onSubmit={handleSubmit}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ResourceEdit